import { setTaskListFiltes } from "../../../redux/actions/users";
import store from "../../../redux/store";



const setTaskListFilters = async (data) => {
    await localStorage.setItem('SET_TASK_LIST_FILTERS', JSON.stringify(data));
    await store.dispatch(setTaskListFiltes(data));
};


const clearTaskListFilters = async () => {
    await localStorage.setItem('SET_TASK_LIST_FILTERS', JSON.stringify(''));
    await store.dispatch(setTaskListFiltes( {
        assignBy: [],
        wards: [],
        taskPriorities: null,
        taskStatus: null
    }));
};



export const filtersController = {
    setTaskListFilters,
    clearTaskListFilters
};